import { NamedValue, GenericReferral } from "./types";

export const DEFAULT_CLUSTER: string = "-";
export const DEFAULT_DEPARTMENT: string = "-";
export const DEFAULT_TYPE: string = "-";
export const DEFAULT_PRIORITY: string = "-";

export interface AuthenticationConfiguration {
  authenticationType: string;
  clientId: string;
  authority: string;
  redirectUri: string;
  postLogoutRedirectUri: string;
  scopes: string[];
}

export interface ApplicationConfiguration {
  version: string;
  showMainMenu: boolean;
  autoHideNonClosedReferrals: boolean;
  manualCloseEnabled: boolean;
  patientNumberEditEnabled: boolean;
  inboxNotificationsRepeatUntilReadAll: boolean;
  professionalSummaryEnabled: boolean;
  selfReferrerEnabled: boolean;
  patientSearchByPatientNrEnabled: boolean;
  patientSearchByPatientBsnEnabled: boolean;
  patientSearchByFamilyNameEnabled: boolean;
  patientSearchByBirthDateEnabled: boolean;
  patientNumberDepartmentOverruleEnabled: boolean;
  zorgIDEnvironmentCode: string;
  enableTeamsCallAmbulance: boolean;
}

export interface UserPermissions {
  view: boolean;
  assignPatientNumber: boolean;
  requestProfessionalSummary: boolean;
  setReferralState: boolean;
  copyLinkToClipboard: boolean;
  downloadReferralAsPdf: boolean;
  toggleAdvancedMode: boolean;
  toggleDeveloperMode: boolean;
  patientTransporterView: boolean;
}

/* Vuex state types  */
export interface RootState {
  authenticationConfiguration: AuthenticationConfiguration;
  applicationConfiguration: ApplicationConfiguration;
  socketIsConnected: boolean;
  userPermissions: UserPermissions;
  playSoundNotificationReferrals: boolean;
}

export class ESpoedState {
  public clusters: Array<NamedValue>;
  public departments: Array<NamedValue>;
  public types: Array<NamedValue>;
  public priorities: Array<NamedValue>;
  public currentCluster: string;
  public currentDepartment: string;
  public currentType: string;
  public currentPriority: string;
  public referrals: Array<GenericReferral>;

  constructor() {
    this.clusters = [];
    this.departments = [];
    this.types = [];
    this.priorities = [];
    this.currentCluster = DEFAULT_CLUSTER;
    this.currentDepartment = DEFAULT_DEPARTMENT;
    this.currentType = DEFAULT_TYPE;
    this.currentPriority = DEFAULT_PRIORITY;
    this.referrals = [];
  }
}
